import React, { Component } from 'react'

import ContMessageI18N from '../../containers/ContMessageI18N';

class CustomerCriteria extends Component {

	handleChangeGeneric = name => event => {
		this.handleChange({ [name]: event.target.value }, name);
	};
	handleChange(data, name) {
		this.props.onChange({ ...this.props.context.customer, [name]: data[name] });
	}

	getMessage(i18nKey) { return <ContMessageI18N i18n={i18nKey} /> }

	render() {
		var postCodeValue = this.props.context.customer.postCode == null ? '' : this.props.context.customer.postCode;
		var youngestDriverAge = this.props.context.customer.youngestDriverAge;

		return (
			<React.Fragment>
				{this.props.availableValues != null && this.props.availableValues.youngestDriverAge != null && this.props.availableValues.youngestDriverAge.values != null &&
					<div className="col-auto form-floating">
						<select className="form-select" id="calculator-youngestDriverAge"
							onChange={this.handleChangeGeneric('youngestDriverAge')} value={youngestDriverAge}>
							<option value="" />
							{this.props.availableValues.youngestDriverAge.values.map((value, index) => (
								<option value={value} key={index}>≥ {value}</option>
							))}
						</select>
						<label htmlFor="calculator-youngestDriverAge">{this.getMessage('calculatorPage.criteria.customer.youngestDriverAge')}</label>
					</div>
				}
				{this.props.availableValues != null && this.props.availableValues.postCode &&
					<div className="col-auto form-floating">
						<input id='calculator-postCode' type="text" className="form-control" placeholder={this.getMessage('calculatorPage.criteria.customer.postCode')}
							value={postCodeValue} onChange={this.handleChangeGeneric('postCode')} />
						<label htmlFor='calculator-postCode' >{this.getMessage('calculatorPage.criteria.customer.postCode')}</label>
					</div>
				}
			</React.Fragment>
		)
	}
}

export default (CustomerCriteria)
